import { useEffect, useState } from "react";
import Axios from "axios";
import sha256 from "crypto-js/sha256";
import { ethers } from "ethers";
import { toast } from "react-toastify";

import "./addAlertDlg.css";
import AutocompleteAdd from "../../../components/crudSql/autocompleteAdd/AutocompleteAdd";
import SelectFromArray from "../../intervalsMenu/SelectFromArray";

import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function AddAlertDlg(props) {
  const handleClose = () => {
    props.setOpen(false);
  };

  const handleCloseAdd = () => {
    if (!props.userAuthWallet) {
      toast.error("First connect the wallet!");
      return;
    }

    // if (!walletAddress || !ethers.utils.isAddress(walletAddress)) {
    //   toast.error("Please enter valid wallet address!");
    //   return;
    // }

    let err = "";
    if (inputs.trackedParameter === undefined || !inputs.trackedParameter)
      err += "Please choose Tracked Parameter!\n";
    else if (inputs.trackedParameter != "balRwd") {
      if (inputs.addAlertThreshold === undefined || !inputs.addAlertThreshold)
        err += "Please enter valid threshold!\n";
      if (inputs.addAlertDays === undefined || !inputs.addAlertDays)
        err += "Please enter valid interval!\n";
    }
    if (err.length > 0) {
      toast.error(err);
      return;
    }

    const apiUrl = "/alert/add";
    Axios.post(process.env.REACT_APP_CRUD_SRV + apiUrl, {
      tracked: inputs.trackedParameter,
      threshold: inputs.addAlertThreshold,
      interval: inputs.addAlertDays,
      auth: props.userAuthWallet,
      cs: sha256(
        apiUrl + props.userAuthWallet + process.env.REACT_APP_SECRET
      ).toString(),
    }).then((r) => {
      if (r.data?.status == 200) {
        console.log("Alert " + inputs.trackedParameter + " has been added.");
        props.getAlerts();
      } else {
        console.log(r.data);
        toast.error("Allert add error. Please wait for some time and try again.");
      }
    });

    props.setOpen(false);
  };

  const initialState = (props) => {
    return {
      // wallet: "",
      // blockchain: "",
      // platform: "",
      // vault: "",
      // uses: "",
      // name: "",
      // remark: "",
      trackedParameter: "",
    };
  };
  const [inputs, setInputs] = useState(initialState);
  // const [blockchains, setBlockchains] = useState([]);
  const [droppedValA, setDroppedValA] = useState([
    { title: "10%" },
    { title: "20%" },
    { title: "25%" },
    { title: "33%" },
    { title: "50%" },
    { title: "66%" },
    { title: "75%" },
    { title: "90%" },
    { title: "100%" },
  ]);
  const [droppedAprA, setDroppedAprA] = useState([
    { title: "5%" },
    { title: "10%" },
    { title: "20%" },
    { title: "30%" },
    { title: "50%" },
    { title: "75%" },
    { title: "100%" },
    { title: "150%" },
    { title: "200%" },
    { title: "300%" },
    { title: "500%" },
    { title: "1,000%" },
    { title: "10,000%" },
  ]);
  const [droppedDaysA, setDroppedDaysA] = useState([
    { title: "1 day" },
    { title: "3 days" },
    { title: "7 days" },
    { title: "14 days" },
    { title: "30 days" },
    { title: "90 days" },
    { title: "180 days" },
    { title: "365 days" },
  ]);

  // Изменяем value заданного инпута при вводе внутри этого поля
  function inputChange(evt) {
    // console.log("inputChange", evt.target.label, evt.target.value);

    setInputs({
      ...inputs,
      [evt.target.name]: evt.target.value,
    });
  }

  function autocompleteChange(name, val) {
    setInputs({
      ...inputs,
      [name]: val,
    });
  }

  useEffect(() => {
    console.log(inputs);
  }, [inputs]);

  const [walletAddress, setWalletAddress] = useState("");

  function handleWalletAddressChange(evt) {
    // console.log(evt.target.value);
    setWalletAddress(evt.target.value);
  }

  const [walletName, setWalletName] = useState("");

  function handleWalletNameChange(evt) {
    // console.log(evt.target.value);
    setWalletName(evt.target.value);
  }

  return (
    <>
      {/* <Button variant="outlined" onClick={handleClickOpen}>
        Open form dialog
      </Button> */}
      <Dialog open={props.open} onClose={handleClose} className="addAlertDlg">
        <DialogTitle>Add Alert</DialogTitle>
        <DialogContent>
          <DialogContentText>
            To add alert, please choose Tracked Parameter and enter tracked
            threshold.
          </DialogContentText>
          {/* <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Email Address"
            type="email"
            fullWidth
            variant="standard"
          /> */}
          {/* <TextField
            autoFocus
            margin="dense"
            id="name"
            label="TVL"
            type="text"
            fullWidth
            variant="standard"
            onChange={handleWalletAddressChange}
          /> */}
          <SelectFromArray
            label="Tracked Parameter"
            optionsA={props.trackedParametersA}
            name="trackedParameter"
            val={inputs}
            setVal={inputChange}
          />

          {inputs.trackedParameter != "balRwd" && (
            <>
              <AutocompleteAdd
                name="addAlertThreshold"
                value={inputs.addAlertThreshold}
                className="platform firstChild"
                data={
                  inputs.trackedParameter.includes("Apr")
                    ? droppedAprA
                    : droppedValA
                }
                label={
                  inputs.trackedParameter.includes("Apr")
                    ? "below the specified *, i.e. 10%"
                    : "has dropped by *, i.e. 33%"
                }
                onChg={autocompleteChange}
                required
              />
              <AutocompleteAdd
                name="addAlertDays"
                value={inputs.addAlertDays}
                className="platform"
                data={droppedDaysA}
                label="in the last *, i.e. 30 days"
                onChg={autocompleteChange}
                required
              />
            </>
          )}

          {/* <TextField
            margin="dense"
            id="name"
            label="Wallet Name (Optional)"
            type="text"
            fullWidth
            variant="standard"
            onChange={handleWalletNameChange}
          /> */}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleCloseAdd}>Add Alert</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
